if (!customElements.get('platonline-accessories')) {
  customElements.define('platonline-accessories', class extends HTMLElement {
    connectedCallback() {
      if (this.ready) return;
      this.ready = true;
      this.variant = this.querySelector('[data-extra-variant]');
      this.quantity = this.querySelector('[data-extra-quantity]');
      this.button = this.querySelector('[data-extra-add]');
      this.status = this.querySelector('[role="status"]');
      this.total = this.querySelector('[data-extra-total]');
      this.money = new Intl.NumberFormat(this.dataset.locale || 'sv', {style:'currency', currency:this.dataset.currency || 'SEK'});
      for (const type of ['input', 'change']) this.addEventListener(type, event => {
        event.stopPropagation();
        this.updateTotal();
      });
      this.addEventListener('keydown', event => {
        if (event.key === 'Enter' && event.target === this.quantity) {
          event.preventDefault();
          event.stopPropagation();
          this.button.click();
        }
      });
      this.button.addEventListener('click', event => {
        event.preventDefault();
        event.stopPropagation();
        this.add();
      });
      this.updateTotal();
    }
    getQuantity() {
      const value = this.quantity.value.trim();
      const number = Number(value);
      return /^\d+$/.test(value) && Number.isSafeInteger(number) && number >= 1 && number <= 999 ? number : null;
    }
    updateTotal() {
      const option = this.variant.selectedOptions[0];
      const quantity = this.getQuantity();
      const price = Number(option?.dataset.price);
      this.total.textContent = this.variant.value && quantity && Number.isFinite(price) ? this.money.format(price * quantity / 100) : '—';
      this.variant.removeAttribute('aria-invalid');
      this.quantity.removeAttribute('aria-invalid');
      if (!this.busy) this.status.textContent = '';
    }
    async add() {
      if (this.busy) return;
      const quantity = this.getQuantity();
      const option = this.variant.selectedOptions[0];
      this.status.dataset.error = 'false';
      if (!this.variant.value || option.disabled || !quantity) {
        const target = !this.variant.value || option.disabled ? this.variant : this.quantity;
        this.status.dataset.error = 'true';
        this.status.textContent = target === this.variant ? this.dataset.choose : this.dataset.invalid;
        target.setAttribute('aria-invalid', 'true');
        target.focus();
        return;
      }
      this.busy = true;
      const id = Number(this.variant.value);
      for (const input of [this.variant,this.quantity,this.button]) input.disabled = true;
      this.setAttribute('aria-busy','true');
      this.status.textContent = this.dataset.adding;
      try {
        const response = await fetch(this.dataset.addUrl, {
          method:'POST', credentials:'same-origin',
          headers:{'Content-Type':'application/json',Accept:'application/json'},
          body:JSON.stringify({items:[{id,quantity}]})
        });
        const result = await response.json();
        if (!response.ok || result.status) throw new Error(result.description || result.message || this.dataset.error);
        this.status.textContent = this.dataset.success;
        this.querySelector('.pl-extra-cart').hidden = false;
        if (this.querySelector('[data-extra-cart-context]') && typeof window.CartReload === 'function') {
          try {
            const refreshed = await fetch(this.dataset.cartUrl.replace(/\.js$/, ''), {credentials:'same-origin',cache:'no-store'});
            if (refreshed.ok) window.CartReload(await refreshed.text());
          } catch (_) {}
        }
        try {
          const cartResponse = await fetch(this.dataset.cartUrl,{credentials:'same-origin',cache:'no-store'});
          if (cartResponse.ok) {
            const cart = await cartResponse.json();
            document.querySelectorAll('.cartCountSelector').forEach(el => {el.textContent=cart.item_count;});
            if (window.Shopify?.formatMoney && window.theme?.moneyFormat) document.querySelectorAll('.cartTotalSelector').forEach(el => {el.innerHTML=window.Shopify.formatMoney(cart.total_price,window.theme.moneyFormat);});
            document.dispatchEvent(new CustomEvent('cart:updated',{detail:{cart},bubbles:true}));
            if (typeof window.CartDrop === 'function') window.CartDrop(true);
          }
        } catch (_) {}
      } catch (error) {
        this.status.dataset.error = 'true';
        this.status.textContent = error instanceof TypeError || error instanceof SyntaxError ? this.dataset.error : error.message || this.dataset.error;
        this.querySelector('.pl-extra-cart').hidden = false;
      } finally {
        this.busy = false;
        this.removeAttribute('aria-busy');
        for (const input of [this.variant,this.quantity,this.button]) input.disabled = false;
      }
    }
  });
}
